// extracted by mini-css-extract-plugin
module.exports = {"container":"Regions_container__FZqEI","value":"Regions_value__JEAGZ"};